import type { Payload } from "../graph/Payload";
import type { IEndpoint } from "../runtime/IEndpoint";

/** Log level for nodes - higher levels include all lower ones */
export enum LogLevel {
  Error = 'error',
  Info = 'info',
  Trace = 'trace'
}


/**
 * Node interface - implemented by primitive nodes and graph instances
 */
export interface INode {
  readonly id: string;
  readonly type: string;
  params?: Record<string, any>;
  logLevel: LogLevel;

  initialize(): void;

  /** Param value (from config, UI tweak, or connection). source undefined for config/UI. */
  onParamChanged(payload: Payload, endpointId: string, source?: IEndpoint): void;

  /** Internal data (always from connection) */
  onInternalChanged(payload: Payload, endpointId: string, source: IEndpoint): void;

  /** Event data (always from connection) */
  handleEvent(payload: Payload, endpointId: string, source: IEndpoint): void;

  /** Trigger (always from connection) */
  handleTrigger(payload: Payload, endpointId: string, source: IEndpoint): void;

  /** Called when a connection is removed */
  onDisconnected(endpointId: string, source: IEndpoint): void;

  /** Per-frame animation: evaluate expressions and push output. Override in subclasses. */
  animate(): void;

  onConnectedFrom(endpointId: string, source: IEndpoint): void;
  onDisconnectedFrom(endpointId: string, source: IEndpoint): void;
  onConnectedTo(endpointId: string, targetNode: INode, targetEndpoint: IEndpoint): void;
  onDisconnectedTo(endpointId: string, targetNode: INode, targetEndpointId: string): void;
  dispose(): void;
}
